/**
 * Contains everything from ConfigurationSummaryConfirmationCardTypeEnum except
 * those related to VPC success, since SummaryPage uses a different card for that.
 */
var SummaryPageConfirmationCardTypeEnum;
(function (SummaryPageConfirmationCardTypeEnum) {
    SummaryPageConfirmationCardTypeEnum["addToCartSuccess"] = "addToCartSuccess";
    SummaryPageConfirmationCardTypeEnum["addToListSuccess"] = "addToListSuccess";
    SummaryPageConfirmationCardTypeEnum["saveVpcFail"] = "saveVpcFail";
    SummaryPageConfirmationCardTypeEnum["addUnavailabeToCartAndListSuccess"] = "addUnavailabeToCartAndListSuccess";
    SummaryPageConfirmationCardTypeEnum["addUnavailabeToCartFailAndListSuccess"] = "addUnavailabeToCartFailAndListSuccess";
    SummaryPageConfirmationCardTypeEnum["addUnavailabeToCartSuccessAndListFail"] = "addUnavailabeToCartSuccessAndListFail";
})(SummaryPageConfirmationCardTypeEnum || (SummaryPageConfirmationCardTypeEnum = {}));
export default SummaryPageConfirmationCardTypeEnum;
//# sourceMappingURL=SummaryPageConfirmationCardTypeEnum.js.map